import { AmplifilesClient } from "./api-client";
import { HomeResponseDto } from "@repo/api/home";

export class HomeApi {
  static async getHome(teamExternalId: string) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/home`,
    );
    return HomeResponseDto.parse(response.data);
  }
}
